<div *ngIf="orders.length <= 0" class="d-flex py-5 h-75 align-items-center justify-content-center bg-light">
  <ng-container >
    <div class="card shadow-lg h-100 w-75 border-0 rounded-4">
      <div class="text-center py-5 card-body d-flex flex-column align-items-center justify-content-center">
        <!-- Icon -->
        <i class="fas fa-shopping-cart fa-3x text-muted mb-4"></i>

        <!-- Title -->
        <h4 class="fw-bold text-muted mb-3">No Orders Yet</h4>

        <!-- Subtitle -->
        <p class="text-secondary mb-4">
          It seems like you haven't placed any orders yet.<br />
          Start shopping now to see your orders here!
        </p>

        <!-- Button -->
        <button class="btn btn-danger btn-lg rounded-pill px-5" (click)="redirectToShop()">
          Shop Now
        </button>
      </div>
    </div>
  </ng-container>
</div>
<section class="h-100 gradient-custom" style="background-color: #eee; width: 100%;">
  <div class="container py-2 h-100">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col-lg-12 col-xl-12" *ngIf="orders.length">
        <div class="card" style="border-radius: 10px;">
          <div class="card-header px-4 py-3">
            <h5 class="text-muted mb-0 bold">
              Thanks for your Order,<span class="text-danger">{{ customer.firstName }} {{ customer.lastName }}</span>!
            </h5>
          </div>
          <div *ngFor="let order of orders; let i = index" class="card-body p-4" >
            <div class="d-flex justify-content-between align-items-center mb-4">
              <p class="fw-bold fw-normal mb-0 text-danger fs-6 fs-md-4">
                STATUS: <span class="text-danger">{{ order.status }}</span>
              </p>
              <a class="small text-muted mb-0" role="button" (click)="navigateToOrder(order.id)" >
                <i class="pi pi-external-link" style="font-size: 1rem" ></i> Order Id: <span>#{{ order.id }}</span>
              </a>
            </div>

            <!-- Order Item -->
            <div class="card shadow-0 border mb-4">
              <div class="card-body">
                <a role="button" (click)="navigateToOrder(order.id)">
                <div class="row d-flex flex-wrap align-items-center">
                  <!-- Image -->
                  <div class="col-md-3 text-center mb-3">
                    <img
                      [src]="order.imageUrl"
                      class="rounded productImage"
                      [alt]="order.modelNumber"
                    />
                  </div>

                  <!-- Details -->
                  <div class="col-md-9 d-flex flex-column flex-md-row justify-content-between">
                    <!-- Model and Brand -->
                    <div class="d-flex flex-column align-items-start mb-2 mb-md-0">
                      <p class="mb-0 fw-bold">
                        <span>{{ order.brand +" "+ order.modelNumber +" | "+ order.color }}</span>
                      </p>
                    </div>

                    <!-- Quantity and Price -->
                    <div class="d-flex  align-items-center justify-content-start gap-md-5 gap-4 justify-content-md-center-around">
                      <p class="text-muted mb-0 me-md-3">
                        <span class="fw-bold me-1">Qty:</span>
                        {{ order.quantity }}
                      </p>
                      <p class="text-muted mb-0 ms-md-5">
                        <span class="fw-bold me-1">Price:</span>
                        {{ order.totalPrice | currency: "INR" }}
                      </p>
                    </div>
                  </div>
                </div>
                </a>
                <!-- Delivered Information -->
                <div
                  class="d-flex flex-wrap justify-content-between align-items-center my-1 pt-1"
                  *ngIf="order.status == 'DELIVERY_SUCCESS' || order.status == 'SETTLED'">
                  <div class="fw-bold col-6 text-left text-muted">
                    Delivered on :
                    <span class="fw-normal d-block d-md-inline-block flex-wrap">{{ order.billedTimestamp | amDateFormat: 'Do MMMM YYYY' }}</span>
                  </div>
                  <div>
                    <button
                      class="btn btn-danger fs-12 fs-sm-6 text-white px-2 py-1 "
                      (click)="downloadInvoice(order)">
                      Download Invoice
                    </button>
                  </div>
                </div>

                <!-- Ordered Information -->
                <div class="row justify-content-between align-items-center my-2"  *ngIf="order.billedTimestamp == null ">
                  <div class="fw-bold col-8 text-left text-muted">
                    Ordered on :
                    <span class="fw-normal  d-block d-md-inline-block flex-wrap">{{ order.createdTimeStamp | amDateFormat: 'Do MMMM YYYY' }}</span>
                  </div>
                  <div class="col-4 text-end">
                    <button
                      class="btn btn-danger text-white px-1 border-0 rounded-1 small "
                      *ngIf="order.status != 'CANCELLED' " (click)="openModal(order)">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<p-dialog [header]="'Order Cancel Request #'+selectedOrder?.id" [modal]="true" [(visible)]="visible" [style]="{ width: '35rem' }">
    <div class="modal-body medium py-5" *ngIf="selectedOrder">
      <div class="container">
          <div class="fs-16" style="opacity: 0.8;"><b>{{selectedOrder.brand}} {{selectedOrder.modelnumber}} {{selectedOrder.quantity}}pcs.</b></div>
          <div style="margin:20px 0 20px 0">
            <label><b>Select Reason</b></label>
            <select class="form-control selectopt" name="subject" [(ngModel)]="reason" required>
              <option value="" disabled selected>Please Select the reason</option>
              <option value="Product available at Low price in other shop.">Product available at Low price in other shop.</option>
              <option value="Order Created by Mistake.">Order Created by Mistake.</option>
              <option value="Delay delivery cancellation.">Delay delivery cancellation.</option>
              <option value="Product not required anymore.">Product not required anymore.</option>
              <option value="Want to change the product.">Want to change the product.</option>
              <option value="Shipping cost too high.">Shipping cost too high.</option>
            </select>
          </div>
          <div class="text-center mt-2"><b>Are you sure, you want to cancel the order?</b></div>
          <div class="row">
            <div class="text-center">
              <button class="btn btn-danger btn-sm text-white px-4 py-2" (click)="cancelRequest()">
                <a class="text-white">Send Cancel Request</a>
              </button>
            </div>
          </div>
      </div>
    </div>
</p-dialog>

<!--pi-info-->
